import { useLanguage } from "@/i18n/LanguageContext";
import { useCustomerLogos } from "@/hooks/useCatalog";

export default function CustomerLogos() {
  const { t } = useLanguage();
  const { items: customers } = useCustomerLogos();
  if (!customers.length) return null;
  const loop = [...customers, ...customers];

  return (
    <section className="py-14 md:py-20 border-t border-border bg-card/40 overflow-hidden">
      <div className="container mx-auto px-4 mb-8 text-center">
        <p className="eyebrow mb-3">{t("Our customers")}</p>
        <h2 className="text-2xl md:text-3xl font-bold">
          {t("Trusted by manufacturers of all sizes, across industries and countries")}
        </h2>
        <p className="text-muted-foreground mt-3 max-w-2xl mx-auto text-sm md:text-base">
          {t("Working with businesses of all sizes and sectors, we deliver solutions that contribute to their growth and production performance.")}
        </p>
      </div>

      <div className="relative group">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-background to-transparent z-10" />
        <ul
          className="flex w-max items-center gap-4 animate-marquee group-hover:[animation-play-state:paused] motion-reduce:animate-none"
          aria-label={t("Customer logos")}
        >
          {loop.map((c, i) => (
            <li
              key={`${c.name}-${i}`}
              aria-hidden={i >= customers.length}
              className="shrink-0 w-40 md:w-52 h-20 md:h-24 rounded-xl border border-border bg-background flex items-center justify-center p-4 shadow-sm"
            >
              <img
                src={c.src}
                alt={`${c.name} logo`}
                loading="lazy"
                className="max-h-full max-w-full object-contain"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
